import React, { FC, RefObject } from 'react'
import { Direction, REQUEST_CONFIGS_KEYS } from '@services/constants'
import RadioInput from '../inputs/radio.input'
import { RadioList } from '@utils/request'
import * as utilsList from './__index.utils'
import BlobUploader from '../inputs/azureBlobUploader.input'


const Step3_1TypeUtilisation = ({
	pageAssets,
	pageUtils,
	formInputs,
	errors,
	updateInput,
	isSummaryStep = false,
	// *******
	formFilesInputs,
	updateFileInput,
	updateUploadedFilesMap,
	onSetErrorFromFileComponent,
	toPrint = false
}) => {
	const {
		whatToDo,

		// **********************
		mainUseOfExistingBuilding,
		doYouWantToChangeCurrentUse,
		projectedUse,

		existingMainBuildingIsShared,
	} = formInputs

	const { autorisationInput } = formFilesInputs

	const radioListYesNo: RadioList[] = utilsList.radioListYesNo(pageAssets)

	const radioListMainUseOfExistingBuilding: RadioList[] =
		utilsList.radioListMainUseOfExistingBuildingCommercialPermit(pageAssets)

	const radioListProjectedUse: RadioList[] =
		utilsList.radioListProjectedUse(pageAssets)


	return (
		<>
			{!isSummaryStep && (
				<h4 className={pageUtils.classes.h4}>
					{pageAssets?.request_form_type_of_use}
				</h4>
			)}

			<RadioInput
				name={mainUseOfExistingBuilding.name}
				label={mainUseOfExistingBuilding.label}
				value={mainUseOfExistingBuilding.value}
				list={radioListMainUseOfExistingBuilding}
				direction={Direction.vertical}
				hasError={errors!.includes(mainUseOfExistingBuilding.name)}
				onChange={(value) => updateInput(mainUseOfExistingBuilding.name, value)}
				ref={mainUseOfExistingBuilding.ref as RefObject<HTMLInputElement>}
				required={mainUseOfExistingBuilding.required}
				hasBackgroundWrapper={true}
				isSummaryStep={isSummaryStep}
			/>

			<RadioInput
				name={doYouWantToChangeCurrentUse.name}
				label={doYouWantToChangeCurrentUse.label}
				value={doYouWantToChangeCurrentUse.value}
				list={radioListYesNo}
				direction={Direction.vertical}
				hasError={errors!.includes(doYouWantToChangeCurrentUse.name)}
				onChange={(value) =>
					updateInput(doYouWantToChangeCurrentUse.name, value)
				}
				ref={doYouWantToChangeCurrentUse.ref as RefObject<HTMLInputElement>}
				required={doYouWantToChangeCurrentUse.required}
				hasBackgroundWrapper={true}
				isSummaryStep={isSummaryStep}
			/>

			{doYouWantToChangeCurrentUse.value?.toString() == 'true' && (
				<RadioInput
					name={projectedUse.name}
					label={projectedUse.label}
					value={projectedUse.value}
					list={radioListProjectedUse.filter(
						(item) => item.value !== mainUseOfExistingBuilding.value?.toString()
					)}
					direction={Direction.vertical}
					hasError={errors!.includes(projectedUse.name)}
					onChange={(value) => updateInput(projectedUse.name, value)}
					ref={projectedUse.ref as RefObject<HTMLInputElement>}
					required={projectedUse.required}
					hasBackgroundWrapper={true}
					isSummaryStep={isSummaryStep}
				/>
			)}


			<RadioInput
				name={existingMainBuildingIsShared.name}
				label={existingMainBuildingIsShared.label}
				value={existingMainBuildingIsShared.value}
				list={radioListYesNo}
				direction={Direction.vertical}
				hasError={errors!.includes(existingMainBuildingIsShared.name)}
				onChange={(value) =>
					updateInput(existingMainBuildingIsShared.name, value)
				}
				ref={existingMainBuildingIsShared.ref as RefObject<HTMLInputElement>}
				required={existingMainBuildingIsShared.required}
				hasBackgroundWrapper={true}
				isSummaryStep={isSummaryStep}
			/>

			{autorisationInput &&
				existingMainBuildingIsShared.value == radioListYesNo[0].value && (
					<>
						<BlobUploader
							name={autorisationInput.name}
							subtitle={autorisationInput.label}
							description={pageAssets?.request_form_required_documents_description_oneDocument_label}
							required={autorisationInput.required}
							files={autorisationInput.files}
							uploadedFilesMap={autorisationInput.uploadedFilesMap}
							hasError={errors.includes(autorisationInput.name)}
							onSetFiles={(files) =>
								updateFileInput(autorisationInput.name, files)
							}
							setUploadedFilesMap={(uploadedFilesMap) =>
								updateUploadedFilesMap(autorisationInput.name, uploadedFilesMap)
							}
							maxFiles={autorisationInput.numberMaxFiles}
							onSetHasError={onSetErrorFromFileComponent}
							isSummary={isSummaryStep}
							toPrint={toPrint}
						/>
						<br />
					</>
				)}
		</>
	)
}

export default Step3_1TypeUtilisation
